import React from "react";
import "./EarningsSummary.css";

const EarningsSummary = ({ summary }) => {
  const averagePerOrder =
    summary.totalOrders > 0
      ? (
          summary.totalEarnings /
          summary.totalOrders
        ).toFixed(2)
      : 0;

  const cards = [
    {
      title: "Total Earnings",
      value: `₹${summary.totalEarnings.toLocaleString()}`,
      icon: "💰",
      color: "#16a34a",
    },
    {
      title: "Today's Earnings",
      value: `₹${summary.todayEarnings.toLocaleString()}`,
      icon: "📅",
      color: "#2563eb",
    },
    {
      title: "Weekly Earnings",
      value: `₹${summary.weeklyEarnings.toLocaleString()}`,
      icon: "📈",
      color: "#9333ea",
    },
    {
      title: "Monthly Earnings",
      value: `₹${summary.monthlyEarnings.toLocaleString()}`,
      icon: "🗓️",
      color: "#ea580c",
    },
    {
      title: "Pending Settlement",
      value: `₹${summary.pendingSettlement.toLocaleString()}`,
      icon: "⏳",
      color: "#dc2626",
    },
    {
      title: "Completed Orders",
      value: summary.totalOrders,
      icon: "🍽️",
      color: "#0891b2",
    },
    {
      title: "Average / Order",
      value: `₹${averagePerOrder}`,
      icon: "📊",
      color: "#7c3aed",
    },
  ];

  return (
    <div className="earnings-summary">
      {cards.map((card, index) => (
        <div
          key={index}
          className="summary-card"
        >
          <div
            className="summary-icon"
            style={{
              background: card.color,
            }}
          >
            {card.icon}
          </div>

          <div className="summary-content">
            <h4>{card.title}</h4>
            <h2>{card.value}</h2>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EarningsSummary;